@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (pageReady && AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div>
      <div class="text-900 font-medium text-xl mb-3"><h3>Extra</h3></div>
      <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span>
        After you have created an extra you will need to tell the system which packages can sell it.  This is done through the package editor page.
      </p>
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid p-fluid">
          <div class="field mb-4 col-12">
            <label for="extraname" class="font-medium">Name</label>
            <input [(ngModel)]="Extra.name" [ngStyle]="{'border-color': (extraNameValid==false) ? '#FF0000':''}"  id="extraname" type="text" pInputText>
          </div>
          @if (!extraNameValid) {
            <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Extra name.</div>
          }
          <div class="field mb-4 col-12">
            <label for="extradesc" class="font-medium">Description</label>
            <input [(ngModel)]="Extra.description" [ngStyle]="{'border-color': (extraNameValid==false) ? '#FF0000':''}"  id="extradesc" type="text" pInputText>
          </div>
          @if (!extraDescValid) {
            <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Extra Description.</div>
          }
          <div class="field mb-4 col-12">
            <label for="extraImageFile" class="font-medium">Image (optional)</label>
            <p class="m-0 mb-3 text-600 line-height-3">
              <span class="pi pi-info-circle" style="margin-right:4px;"></span>
              Shown beside this extra in the Booking Wizard at 100 x 100 pixels. Use a square image - 100 x 100 pixels works, or 200 x 200 pixels for extra sharpness on phones. Other shapes are fitted inside the square rather than cropped. The file must be smaller than 100KB.
            </p>
            <p-fileupload id="extraImageFile" style="float:left;margin-right:10px;" mode="basic" [auto]="true" name="image" url="{{HTMLbmxurl}}/imageupload/{{VenueID}}/{{Identifier}}" accept="image/*" maxFileSize="100000" (onUpload)="uploadedFile($event)" (onError)="onErrorFileUpload($event)" chooseLabel="Upload Image"></p-fileupload>
            @if (FileChosen != null && FileChosen != '') {
              <button pButton pRipple type="button" style="float: left;margin-bottom: 10px;margin-top: 1px !important;height: 50px;" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeImage()">
                <span style="margin-right:10px;" class="pi pi-times"></span>
                Remove Image
              </button>
            }
            <div style="clear:both;width:100%"></div>
            @if (FileChosen != null && FileChosen != '') {
              <div style="margin-top:10px;">
                <p style="margin-bottom:8px;">This is how your image will look in the Booking Wizard.</p>
                <div style="display:flex; align-items:flex-start; gap:12px; max-width:460px;">
                  <img [src]="FileChosen" alt="" style="flex:none; width:100px; height:100px; object-fit:contain; border-radius:6px;">
                  <div>
                    <span>{{Extra.name}}</span><br>
                    <span style="font-size: 12px;">{{Extra.description}}</span>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="field mb-4 col-12">
            <label for="extravariablevalue" class="font-medium">Is this a Variable Value Extra?</label>
            <p-selectbutton id="extravariablevalue" [style]="{'width': '350px'}" [options]="stateOptionsYesNo" [(ngModel)]="Extra.variablevalue" (onChange)="variableValueChanged()"></p-selectbutton>
            <small class="block mt-1" style="color:#6c757d;">A variable value extra has no set price. Staff type the value in when they add it to a booking, so it is always a Venue Only Extra.</small>
          </div>
          <!-- A variable value extra has no price of its own - the value is typed in on the booking. -->
          @if (!Extra.variablevalue) {
            <div class="field mb-4 col-12">
              <label for="extraoptionprice" class="font-medium">Price</label>
              <p-inputnumber [(ngModel)]="Extra.price" mode="currency" currency="{{CurrencySymbol}}" locale="en-GB" [min]="0" [max]="9999"></p-inputnumber>
            </div>
          }
          <div class="field mb-4 col-12">
            <label for="agegroupname" class="font-medium">Would you like this to be a Venue Only Extra?</label>
            <!-- Locked on Yes while the extra is variable value. -->
            <p-selectbutton [style]="{'width': '350px'}" [options]="stateOptionsYesNo" [(ngModel)]="Extra.venueextras" [disabled]="Extra.variablevalue == true"></p-selectbutton>
            @if (Extra.variablevalue) {
              <small class="block mt-1" style="color:#6c757d;">Variable value extras can only be added by the venue.</small>
            }
          </div>
          <div class="field mb-4 col-12">
            <label for="agegroupname" class="font-medium">Would you like to ask a question with this extra?</label>
            <p-selectbutton [style]="{'width': '350px'}" [options]="stateOptionsYesNo" [(ngModel)]="askQuestion" ></p-selectbutton>
          </div>
          @if (askQuestion) {
            <div class="field mb-4 col-12">
              <label for="extradesc" class="font-medium">Question Text</label>
              <input [(ngModel)]="Extra.question" [ngStyle]="{'border-color': (questionValid==false) ? '#FF0000':''}" [maxlength]="255" id="extradesc" type="text" pInputText>
            </div>
          }
          @if (!questionValid) {
            <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Question.</div>
          }
          <div class="field mb-4 col-12">
            <label for="agegroupname" class="font-medium">Do you want this extra to be available on all days, on chosen days, or on a single date?</label>
            <p-selectbutton [style]="{'width': '480px'}" [options]="stateOptions3" [(ngModel)]="DayMode" ></p-selectbutton>
          </div>
          @if (DayMode == 'SINGLEDATE') {
            <div class="field mb-4 col-12">
              <label for="extrasingledate" class="font-medium">Which date is this extra available on?</label>
              <p-datepicker [selectOtherMonths]="true" inputId="extrasingledate" [(ngModel)]="SingleDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" [style]="{'width': '300px'}" (onSelect)="DoValidCheck()"></p-datepicker>
              <small class="block mt-1" style="color:#6c757d;">The extra is only offered on this one date, whichever day of the week it falls on.</small>
            </div>
          }
          @if (!singleDateValid) {
            <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must choose a date.</div>
          }
          @if (DayMode == 'CHOOSEDAYS') {
            <div>
              <div class="field mb-4 col-12">
                <label for="agegroupname" class="font-medium">Monday</label>
                <p-selectbutton [style]="{'width': '150px'}" [options]="stateOptions" [(ngModel)]="Extra.monday" ></p-selectbutton>
              </div>
              <div class="field mb-4 col-12">
                <label for="agegroupname" class="font-medium">Tuesday</label>
                <p-selectbutton [style]="{'width': '150px'}" [options]="stateOptions" [(ngModel)]="Extra.tuesday" ></p-selectbutton>
              </div>
              <div class="field mb-4 col-12">
                <label for="agegroupname" class="font-medium">Wednesday</label>
                <p-selectbutton [style]="{'width': '150px'}" [options]="stateOptions" [(ngModel)]="Extra.wednesday" ></p-selectbutton>
              </div>
              <div class="field mb-4 col-12">
                <label for="agegroupname" class="font-medium">Thursday</label>
                <p-selectbutton [style]="{'width': '150px'}" [options]="stateOptions" [(ngModel)]="Extra.thursday" ></p-selectbutton>
              </div>
              <div class="field mb-4 col-12">
                <label for="agegroupname" class="font-medium">Friday</label>
                <p-selectbutton [style]="{'width': '150px'}" [options]="stateOptions" [(ngModel)]="Extra.friday" ></p-selectbutton>
              </div>
              <div class="field mb-4 col-12">
                <label for="agegroupname" class="font-medium">Saturday</label>
                <p-selectbutton [style]="{'width': '150px'}" [options]="stateOptions" [(ngModel)]="Extra.saturday" ></p-selectbutton>
              </div>
              <div class="field mb-4 col-12">
                <label for="agegroupname" class="font-medium">Sunday</label>
                <p-selectbutton [style]="{'width': '150px'}" [options]="stateOptions" [(ngModel)]="Extra.sunday" ></p-selectbutton>
              </div>
            </div>
          }
          <div class="field mb-4 col-12">
            <label for="agegroupname" class="font-medium">Per Extra or per Booking?</label>
            <p-selectbutton [style]="{'width': '350px'}" [options]="stateOptions2" [(ngModel)]="Extra.perPerson" ></p-selectbutton>
          </div>
          <div class="field mb-4 col-12">
            <label for="" class="font-medium">Tag(s)</label><br/>
            <p-multiselect [options]="tags" optionLabel="name"  [(ngModel)]="Extra.tags" display="chip">
              <ng-template let-value #selecteditems>
                @for (tag of Extra.tags; track tag) {
                  <span>
                    <p-chip class="mr-2" label="{{tag.name}}" [style]="{'background': tag.colour, 'color': 'white', 'border-radius': '5px', 'font-size': '100%' }"></p-chip>
                  </span>
                }
                @if (!Extra.tags || Extra.tags.length === 0) {
                  <div class="country-placeholder">
                    Select Tag(s)
                  </div>
                }
              </ng-template>
            </p-multiselect>
          </div>
          <!--
          <div class="col-12 md:col-6 drag-column">
            <div *ngFor="let product of availableExtraOptions">
              <div class="product-item" pDraggable="products" (onDragStart)="dragStart($event, product)" (onDragEnd)="dragEnd()">
                <div class="product-list-detail">
                  <h5 class="mb-2">{{product.name}}</h5>
                </div>
              </div>
            </div>
          </div>
          -->
          <!--<div class="col-12 md:col-6 drag-column">
          <label for="agegroupname" class="font-medium">Available Extra Options</label>
          <p-table [value]="availableExtraOptions">
            <ng-template pTemplate="header">
              <tr>
                <th style="width:90%">Name</th>
                <th style="width:10%">&nbsp;</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
              <tr pDraggable="products" (onDragStart)="dragStart($event, product)" (onDragEnd)="dragEnd()">
                <td>{{product.name}}</td>
                <td>
                  <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-success w-auto mt-3" (click)="AddToList(product)">
                    <span class="pi pi-angle-right"></span>
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <div *ngIf="availableExtraOptions.length == 0" style="padding: 15px;">
            <i>No extras options available, add some <a href="/extraoptionedit/0">here</a></i>
          </div>
        </div>
        <div class="col-12 md:col-6 drop-column" pDroppable="products" (onDrop)="drop()">
          <label for="agegroupname" class="font-medium">Selected Extra Options</label>
          <p-table [value]="Extra.extraOptions">
            <ng-template  pTemplate="header" let-columns>
              <tr>
                <th>&nbsp;</th>
                <th style="width:90%">Name</th>
                <th style="width:10%">&nbsp;</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-columns="columns" let-index="rowIndex">
              <tr [pReorderableRow]="index">
                <td>
                  <span class="pi pi-bars" pReorderableRowHandle></span>
                </td>
                <td>{{product.name}}</td>
                <td>
                  <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="RemoveFromList(product)">
                    <span class="pi pi-angle-left"></span>
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>-->
      </div>
      <div class="col-12">
        <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
          <span class="pi pi-pencil" style="margin-right:8px;"></span>
        Save Changes</button>
        &nbsp;
        <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
          <span class="pi pi-times" style="margin-right:8px;"></span>
        Cancel</button>
      </div>
    </div>
  </div>
</div>
}


<style>

</style>
